export { default } from "./SponsoredLabel";
